export default {
  orderDetails: null,
  selectedMedicines: null,
  shippingDate: null,
  state: null,
  city: null,
  branch: null,
  schedule: null,
  scheduleName: null,
  shippingFee: 0,
  provider: null,
  patient: null,
  address: null,
  observations: null,
  phone: null,
  cellPhone: null,
  nameNomenclature: null,
  numberOne: null,
  numberTwo: null,
  numberThree: null,
  minDate: null,
  maxDate: null,
  branchName: null,
  branchAddress: null,
  propertyType: null,
  complementOne: null,
  blockOrInside: null,
  complementTwo: null
}
